import { gql, TypedDocumentNode } from '@common/hooks';
import {
  UpdateSupplierTierMutationCgResponse,
  UpdateSupplierTierMutationVariables,
} from '@common/graphql/schema';

export const UpdateSupplierTierMutation: TypedDocumentNode<
  UpdateSupplierTierMutationCgResponse,
  UpdateSupplierTierMutationVariables
> = gql`
  mutation UpdateSupplierTier($input: CreateOrganizationSupplierTierInput!) {
    createOrganizationSupplierTier(input: $input) {
      success
    }
  }
`;
